import { render } from "./SettingsBasic.vue?vue&type=template&id=1e84dd0a"
import script from "./SettingsBasic.vue?vue&type=script&lang=js"
export * from "./SettingsBasic.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./SettingsBasic.vue?vue&type=style&index=0&id=1e84dd0a&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script